<template lang="pug">
    div.navbar
        div.navbar-left
            img(
                width="152px"
                height="28px"
                src="~assets/imgs/xyt-logo.png"
            )
        div.navbar-middle-single(v-if="userInfo")
            div(
                v-for="(item,index) in currentMenus"
                :key="index"
            )
                div(
                    v-if="selectedMenuItem !== ''"
                    class="menu-item"
                    @click="changeMenu(item)"
                )
                    svg-icon(
                        :icon-class="selectedMenuItem === item.type ? transferStr(item.type) + '-active' : transferStr(item.type)"
                        className="svg-icon"
                    )
                    span(:class="selectedMenuItem === item.type ? 'active-color': 'default-color'") {{ item.name === '首页' ? '首页' : item.name }}
        //- div.navbar-middle-group(v-else)
        //-     div.menu-item(@click="changeMenu(currentMenus[0])")
        //-         svg-icon(
        //-             :icon-class="selectedMenuItem === currentMenus[0].type ? transferStr(currentMenus[0].type) + '-active' : transferStr(currentMenus[0].type)"
        //-             className="svg-icon"
        //-         )
        //-         span(:class="selectedMenuItem === currentMenus[0].type ? 'active-color': 'default-color'") {{ currentMenus[0].name === '首页' ? '首页' : currentMenus[0].name }}
        div.navbar-right
            div.navbar-right-name(v-if="userInfo.mode === 2") 多店模式
            el-tooltip(
                v-else
                effect="dark"
                :content="`${fullName}`"
                placement="bottom"
            )
                div.navbar-right-name {{ orgName }}
            div.navbar-right-count(v-if="userInfo.mode === 2") ({{ orgList.length }}家店)
            div.navbar-right-count(v-else-if="userInfo.mode !== 3") (客户数{{customerCount}})
            div.navbar-right-change(
                @click="selectOrganization"
                v-if="userInfo.canSwitch"
                v-track="{ trackKey: 'nav_select_organization_click_switch_store', }"
            ) 切换{{userOrgsType === 'STORE'? '店':'集团'}}
            div.navbar-right-qcode(
                @mouseover="qcodeMouseover"
                @mouseout="qcodeMouseout"
            )
                el-tooltip(
                    effect="light"
                    placement="bottom-end"
                    :visible-arrow="true"
                )
                    div(
                        slot="content"
                        style="display: flex;align-items: flex-start;font-size: 13px;color: #4E4E4E;padding: 10px 10px 5px;"
                    )
                        div(
                            v-for="(item,index) in qcodeArr"
                            :keys="item.name"
                            style="text-align: center;position: relative;"
                            :style="'margin-left:' + index * 45 + 'px'"
                        )
                            img(
                                :src="item.photo"
                                style="margin-bottom: 5px;"
                                :style="'width:' + item.width + 'px;height:' + item.height + 'px;margin-top:' + index * (-5) + 'px;'"
                            )
                            p(v-if="index === 0") {{ item.name }}
                            p(
                                v-else

                            ) {{ item.name }}
                    svg-icon(
                        :icon-class="qcodeIcon"
                        className="svg-icon"
                    )
            //- 消息提醒功能未开发，隐藏入口
            //- div.navbar-right-notify(
            //-     @mouseover="notifyMouseover"
            //-     @mouseout="notifyMouseout"
            //- )
            //-     div.spot
            //-     div.svg-container
            //-         svg-icon(
            //-             :icon-class="notifyIcon"
            //-             className="icon"
            //-         )
        select-organization(
            :selectOrgData="selectOrgData"
            @refresh="refresh"
            v-if="selectOrgData.show"
        )
</template>
<script>
import { mapState } from 'vuex';
import { loginApis, vehicleInsuranceApis } from '@/api';
import { handleParameter } from '@/filters';
import { sonarUrlUtils } from '@/utils';
import selectOrganization from '../../login/components/SelectOrganization';

export default {
    name: 'Navbar',
    components: {
        selectOrganization,
    },
    computed: {
        ...mapState('user', [
            'userInfo',
            'userOrgsType',
            'userMenuList',
            'moduleList',
            'orgList',
        ]),
        orgName() {
            const keyOrg = this.userInfo.orgs.find(val => val.orgId === this.userInfo.lastLoginOrgId);
            return keyOrg.orgName.length > 10 ? `${keyOrg.orgName.substring(0, 9)}...` : keyOrg.orgName;
        },
        fullName() {
            const keyOrg = this.userInfo.orgs.find(val => val.orgId === this.userInfo.lastLoginOrgId);
            return keyOrg.orgName;
        },
        currentMenus() {
            // const groupMenus = [
            //     this.menus[0],
            // ];
            // if (this.userInfo.mode === 2) return this.menus;
            // return this.userInfo.orgType === 'STORE' ? this.menus : groupMenus;
            return this.menus;
        },
    },
    data() {
        return {
            // type与icon名称对应
            menus: [],
            // 选中菜单
            selectedMenuItem: '',
            selectOrgData: {},
            // 客户数
            customerCount: 0,
            qcodeIcon: 'nav-qcode',
            qcodeArr: [
                {
                    photo: sonarUrlUtils.gaiaApp,
                    name: '凯励程CRM APP下载',
                    width: 120,
                    height: 120,
                }, {
                    photo: sonarUrlUtils.gaiaWechat,
                    name: '凯励程CRM微信绑定',
                    width: 124,
                    height: 124,
                },
            ],
            notifyIcon: 'nav-notify',
            wechatStyle: {
                position: 'absolute',
                bottom: '-11px',
                left: '18px',
            },
        };
    },
    methods: {
        selectOrganization() {
            this.selectOrgData = {
                show: true,
                type: 'edit',
                id: this.userInfo.id,
                orgId: this.userInfo.lastLoginOrgId,
                orgType: this.userOrgsType,
                mode: this.userInfo.mode,
                orgList: this.orgList,
            };
        },
        refresh() {
            this.$router.push('/')
                .finally(() => {
                    window.location.reload();
                });
        },
        /**
             * 当前分类存入路由参数
             * sidebar用于获取当前分类下的菜单
             */
        async changeMenu(item) {
            // type小驼峰转为大驼峰存入路由参数
            // const resType = type.charAt(0).toUpperCase() + type.slice(1);
            handleParameter({
                trackKey: 'nav_top_click_top_nav',
                attr: {
                    parent_id: item.pid,
                    present_id: item.id,
                },
            });
            // 多店模式不开放此模块功能
            if (this.userInfo.mode === 2 && (item.name === '店铺管理' || item.name === '大数据赋能')) {
                this.$message({
                    type: 'warning',
                    message: '功能开发中，敬请期待！',
                });
                return;
            }
            if (this.userInfo.mode !== 3 && item.name === '车险管理') {
                const { data } = await vehicleInsuranceApis.getInsuranceServiceStatus();
                if (data && data.status === 'NOT_OPENED') {
                    this.$message({
                        type: 'warning',
                        message: '当前服务未开通，请联系 952149！',
                    });
                    return;
                }
            }
            if (!item.open) {
                this.$message({
                    type: 'warning',
                    message: '功能开发中，敬请期待！',
                });
                return;
            }
            if (!item.children) {
                this.$message({
                    type: 'warning',
                    message: '暂未开通此模块权限，如有需要请向店铺管理员申请开通权限',
                });
                return;
            }
            const currentQuery = this.$route.query;
            this.$router.replace({
                query: {
                    ...currentQuery,
                    navType: item.type,
                },
            });
            this.selectedMenuItem = item.type;
        },
        // type名转换为对应选中未选中图标名
        transferStr(str) {
            let res = str;
            if (str) {
                const arr = str.split('');
                const newArr = arr.map((item) => {
                    const unicode = item.charCodeAt();
                    let resItem = item.toLowerCase();
                    if (unicode < 90 || unicode === 90) resItem = `-${resItem}`;
                    return resItem;
                });
                res = `nav${newArr.join('')}`;
            }
            return res;
        },
        initSelectedType() {
            const type = this.$route.query.navType;
            this.selectedMenuItem = type;
        },
        // 获取客户数量
        async getCustomerCount() {
            try {
                const { data } = await loginApis.getCustomerCount();
                this.customerCount = data.total || 0;
            } catch (err) {
                throw new Error(err);
            }
        },
        // 二维码移入
        qcodeMouseover() {
            this.qcodeIcon = 'nav-qcode-active';
        },
        // 二维码移出
        qcodeMouseout() {
            this.qcodeIcon = 'nav-qcode';
        },
        // 提醒移入
        notifyMouseover() {
            this.notifyIcon = 'nav-notify-active';
        },
        // 提醒移出
        notifyMouseout() {
            this.notifyIcon = 'nav-notify';
        },
    },
    watch: {
        $route: {
            deep: true,
            handler: function handler(val) {
                const type = val.query.navType;
                if (type) this.selectedMenuItem = type;
            },
        },
    },
    mounted() {
        this.initSelectedType();
        if (this.userInfo.mode === 1) {
            this.getCustomerCount();
        }
        this.moduleList.forEach((val) => {
            if (val.type !== 'MODULE' || val.name === 'Settings' || val.name === 'Feedback' || val.name === 'HelpCenter') return;
            const {
                id,
                pid,
                name,
                title,
                open,
                children,
            } = val;
            this.menus.push({
                id,
                pid,
                name: title,
                type: name,
                open,
                children,
            });
        });
    },
};
</script>
<style scoped lang="scss">
    .base-center {
        display: flex;
        align-items: center;
    }
    .base-menu-item {
        @extend .base-center;
        flex-direction: column;
        justify-content: center;
        width: 80px;
        cursor: pointer;
        margin-right: 12px;
        text-align: center;
        span {
            display: inline-block;
            margin-top: 4px;
            @include font_size(text_main_content);
            line-height: 20px;
        }
        .default-color {
            @include font_color(color_base_blue3);
        }
        .active-color {
            @include font_color(color_base_white);
        }
    }
    .navbar {
        height: 80px;
        @extend .base-center;
        justify-content: space-between;
        @include bg_color(color_base_blue6);
        &-left {
            @extend .base-center;
            justify-content: center;
            width: 200px;
            position: relative;
        }
        &-middle {
            &-single {
                flex-grow: 1;
                @extend .base-center;
                justify-content: space-around;
                .menu-item {
                    @extend .base-menu-item;
                }
            }
            &-group {
                flex-grow: 1;
                .menu-item {
                    @extend .base-menu-item;
                }
            }
        }
        &-right {
            @extend .base-center;
            padding-right: 10px;
            &-name {
                @include font_size(text_notify);
                @include font_color(color_base_white);
                margin-right: 10px;
                white-space: nowrap;
            }
            &-count {
                @include font_size(text_notify);
                @include font_color(color_base_blue3);
                margin-right: 10px;
                white-space: nowrap;
            }
            &-change {
                @include font_color(color_base_white);
                @include font_size(text_weak_annotation);
                @include bg_color(color_base_blue5);
                margin-right: 13px;
                // width: 48px;
                height: 23px;
                border-radius: 12px;
                line-height: 17px;
                padding: 3px 6px;
                white-space: nowrap;
                cursor: pointer;
            }
            &-qcode {
                cursor: pointer;
                .svg-icon {
                    width: 30px !important;
                    height: 30px !important;
                }
            }
            &-notify {
                cursor: pointer;
                .spot {
                    @include bg_color(color_base_red6);
                    position: relative;
                    top: 8px;
                    left: 18px;
                    width:6px;
                    height:6px;
                    border-radius: 3px;
                }
                .svg-container {
                    position: relative;
                    top: -3px;
                    .icon {
                        width: 30px !important;
                        height: 30px !important;
                    }
                }
            }
        }
    }
    .svg-icon {
        width: 20px !important;
        height: 23px !important;
    }
</style>
